'use strict';

var App = App || {};

// This handles contact form submissions.
// Validation is handled by the general validation script initializedd in app.js
// Events are bound to the submit button for a given form and crawl the DOM to target that form
// Receive request
// Validate
// Record google client ID and send with form info to database
// On successful AJAX response, record conversion with Google Analytics
// =====> NOTE: The Google Client ID is injected into all form fields inside a GTM container.
App.SiteFormsProcessing = function () {

  var thisForm = null,
      $formContainer = null,
      $formActivityView = null,
      $formActivityViewContent = null,
      $activityViewSuccess = null,
      $activityViewFail = null,
      $activityViewLoading = null,
      activityAnimSpeed = 350,
      activityMessageVisTime = 3000,
      formSourceInitState = null;

  var init = function init() {
    _bindFormSubmitAction();
  };

  /**
   *  Binding the submission to all submit buttons to trigger events on that specific form.
   *  Allows for all actions on the form to be executed by relative DOM traversal
   *
   *  @access private
   *  @return {}
   *
   */
  var _bindFormSubmitAction = function _bindFormSubmitAction() {
    var allFormSubmitButtons = document.getElementsByClassName('js-submit-contact-form');

    Array.prototype.forEach.call(allFormSubmitButtons, function (el, _) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        //This sets the vars to reference this form's elements under this binding
        _setFormVars(this.form);
        _executeSubmission();
      });
    });
  };

  /**
   *  Sets variables that this script will target for this specific form instance.
   *  Sets selected objects relative to the parent form container so all actions are limited to the current form.
   *
   *  @access private
   *  @param {Object} HTMLElement of current form
   *  @return {}
   *
   */
  var _setFormVars = function _setFormVars(form) {
    thisForm = form;
    $formContainer = $(thisForm.parentElement);
    $formActivityView = $formContainer.find('.form-activity-view');
    $formActivityViewContent = $formActivityView.find('.activity-view-content');
    $activityViewSuccess = $formActivityView.find('.message-success');
    $activityViewFail = $formActivityView.find('.message-fail');
    $activityViewLoading = $formActivityView.find('.loading');
  };

  /**
   *  Executes the form submission based on validation and spam check.
   *
   *  @access private
   *  @return {}
   *
   */
  var _executeSubmission = function _executeSubmission() {
    var isValid = Forms.Validation.isValid(thisForm);
    // If the honeypot is tripped kill it.
    // Otherwise we can submit if the form is validated
    if (!Forms.Validation.isHoneypotClear(thisForm)) {
      console.log('honepot error');
      _handleSubmitFail();
      return false;
    } else if (isValid) {
      console.log('form is valid');
      // We blur the active element so that the cursor doesn't show above the
      // loaing/message view on submission. Fixes iOS thing.
      document.activeElement.blur();
      _showLoadingView();

      if (thisForm.classList.contains('contact-form-email')) {
        _submitFormEmail();
      }
    }
  };

  /**
   * This compiles all form data and returns a key/val object with all fields/vals
   *
   *  @access private
   *  @return {Object}
   *
   */
  var _getFormData = function _getFormData() {
    var allFields = [].slice.call(thisForm.querySelectorAll('input, select, textarea')),
        FormData = {};

    // Assigns all field names/values to an object.
    Array.prototype.forEach.call(allFields, function (field) {
      FormData[field.name] = field.value;
    });

    if (FormData['contact_me_by_fax_only'].checked) {
      FormData['contact_me_by_fax_only'] = 'bot';
    } else {
      FormData['contact_me_by_fax_only'] = null;
    }

    // Strip non-numerics from phone number
    if (FormData.phone) FormData.phone = FormData.phone.replace(/\D/g, '');

    return FormData;
  };

  /**
   * This compiles all form data and returns a URI encoded string ready for POST to the CRM script
   * Formats data for standardized input.
   * The destination param adds the POST data that destination PHP scripts test for when looking for legit submissions.
   * Also sets the user agent for sending to DB
   *
   *  @access private
   *  @param {String} - String appended as a parameter for the submission destination
   *  @return {String}
   *
   */
  var _packageFormData = function _packageFormData(destination) {
    var FormData = _getFormData(),
        submitData = [];

    FormData['destination'] = destination;

    // Create an array of data with individually encoded values.
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = Object.keys(FormData)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;

        submitData.push(key + '=' + encodeURIComponent(FormData[key]));
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return encodeURI(submitData.join('&'));
  };

  /**
   *  Sends the form data via AJAX to the conversion tracking script
   *
   *  @access private
   *  @return {}
   *
   */
  var _submitFormEmail = function _submitFormEmail() {
    var formData = _packageFormData('cta_contact'),
        scriptLocation = window.location.protocol + '//' + window.location.hostname + '/site/mail/cta_contact_form.php';(function executeAjaxCall(attemptCount, intervalTiming) {
      intervalTiming = intervalTiming || 1500;

      $.ajax({
        url: scriptLocation,
        data: formData,
        type: 'POST'
      }).done(function (data) {
        _handleSubmitSuccess();
      }).fail(function (jqXHR, textStatus, errorThrown) {
        attemptCount += 1;
        attemptCount <= 1 && setTimeout(function () {
          executeAjaxCall(attemptCount);
        }, intervalTiming);

        // If unsuccessful on the first try, we'll send them the fail message
        // Script will try again up until the attempt limit.
        if (attemptCount == 2) _handleSubmitFail();
      });
    })(0, 1500);
  };

  var _handleSubmitSuccess = function _handleSubmitSuccess() {
    _showSuccessView();

    // Show message view.
    setTimeout(function () {
      _resetForm();

      if ($formContainer.parents('.remodal')) {
        $('[data-remodal-action=close]').click();
        _hideThenClearActivityView();
      } else {
        _hideThenClearActivityView();
      }
    }, activityMessageVisTime);
  };

  var _handleSubmitFail = function _handleSubmitFail() {
    _showFailView();

    setTimeout(function () {
      _hideThenClearActivityView();
    }, activityMessageVisTime);
  };

  var _resetForm = function _resetForm() {
    Forms.Validation.clearErrors(thisForm);
    thisForm.reset();

    if (formSourceInitState) thisForm.setAttribute('data-trigger-source', formSourceInitState);
  };

  var _openNewActivityView = function _openNewActivityView($newView) {
    $formActivityView.fadeIn(activityAnimSpeed, function () {
      $newView.fadeIn();
    });
  };

  var _transitionActivityView = function _transitionActivityView($newView) {
    $formActivityViewContent.fadeOut(activityAnimSpeed, function () {
      $formActivityViewContent.children().hide();
      $newView.show();
    }).fadeIn(activityAnimSpeed);
  };

  var _showLoadingView = function _showLoadingView() {
    if ($formActivityView.is(':visible')) {
      _transitionActivityView($activityViewLoading);
    } else {
      _openNewActivityView($activityViewLoading);
    }
  };

  var _showSuccessView = function _showSuccessView() {
    if ($formActivityView.is(':visible')) {
      _transitionActivityView($activityViewSuccess);
    } else {
      _openNewActivityView($activityViewSuccess);
    }
  };

  var _showFailView = function _showFailView() {
    if ($formActivityView.is(':visible')) {
      _transitionActivityView($activityViewFail);
    } else {
      $activityViewFail.show();
      $formActivityView.fadeIn(activityAnimSpeed);
    }
  };

  var _hideThenClearActivityView = function _hideThenClearActivityView() {
    $formActivityView.fadeOut(function () {
      $formActivityViewContent.children().hide();
    });
  };

  return {
    init: init
  };
}();